<!-- 取消零坦下发弹窗 -->
<template>
    <performance-common-dialog
        :title="'取消零坦下发弹窗'"
        ref="performanceCommonDialog"
        @close="dialogClose"
        :width="'1300px'"
    >
        <template #top>
            <el-form ref="formRef" label-position="right" label-width="100px">
                <el-form-item label="发车单号：">
                    <span>{{ componentsData.dispatchNo }}</span>
                </el-form-item>
            </el-form>
        </template>
        <template #table-list>
            <div class="dispatchOrder-table" v-loading="loading">
                <div class="dispatch-table-header">
                    <el-button
                        type="text"
                        @click="handleCancel"
                        :disabled="!selected.length"
                    >
                        取消
                    </el-button>
                    <el-button
                        type="text"
                        class="dispatch-refresh"
                        icon="el-icon-refresh"
                        @click="handleRefresh"
                    >
                        刷新
                    </el-button>
                </div>
                <table-box
                    ref="tablePage"
                    :selection="true"
                    :columns="config.table.columns"
                    :height="config.table.height"
                    :rows="tableData"
                    @selection-change="handleSelectionChange"
                >
                </table-box>
                <m-page
                    :current-page="currentPage"
                    :pageData="config.page"
                    :total="pageTotal"
                    @on-page-change="pageChange"
                    @on-size-change="sizeChange"
                    class="page-container"
                ></m-page>
            </div>
        </template>
    </performance-common-dialog>
</template>

<script>
import { dictWithUrl } from '@/components/lots/api.js';
import PerformanceCommonDialog from '@/modules/transport/otp/components/PerformanceCommonDialog';
import tableBox from '@/components/lots/tableBox/Index.vue';
import mPage from '@/components/otpPanel/mPage';
import { lingdanSearchCancleOders, lingdanCancleOders } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
import { formatTotalDataList } from './util';
import config from './config.js';

export default {
    components: {
        PerformanceCommonDialog,
        tableBox,
        mPage
    },
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            config,
            loading: true,
            selected: [], // 选中数据
            tableData: [], // 列表数据
            dictionaryCode: [
                'TRANSPORT_STATUS' // 运单状态
            ],
            dictData: {}, // 数据字典集合
            page: {
                pageSize: 10,
                pageNo: 1
            },
            pageTotal: 0,
            currentPage: 1
        };
    },
    mounted () {
        this.getList();
        this.$refs.performanceCommonDialog.show();
    },
    methods: {
        /**
         * @description 使用发车单号查询列表明细
        */
        async getList () {
            const dict = await dictWithUrl(this.dictionaryCode.join(','));
            this.dictData = dict.data;
            const obj = {
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize,
                param: {
                    dispatchNo: this.componentsData.dispatchNo
                }
            };
            this.loading = true;
            lingdanSearchCancleOders(obj).then((res) => {
                if (res && +res.code === 0) {
                    this.tableData = formatTotalDataList(res.data.list || [], this.dictData);
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        /**
         * @description 刷新
        */
        handleRefresh () {
            this.page = {
                pageSize: 10,
                pageNo: 1
            };
            this.getList();
        },
        /**
         * @description 取消
        */
        handleCancel () {
            this.$prompt('撤销原因:', '撤销零坦下发', {
                confirmButtonText: '确定',
                showCancelButton: false,
                customClass: 'cancel-class',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        if (instance.inputValue) {
                            instance.confirmButtonLoading = true;
                            const obj = {
                                cancelRemark: instance.inputValue,
                                taskNos: this.selected.map(item => { return item.taskNo; })
                            };
                            lingdanCancleOders(obj).then((res) => {
                                if (res && +res.code === 0) {
                                    done();
                                }
                            }).finally(() => {
                                instance.confirmButtonLoading = false;
                            });
                        } else {
                            this.$message.warning('请输入撤销原因');
                        }
                    } else {
                        done();
                    }
                }
            }).then(() => {
                this.getList();
                this.$message.success('撤销成功');
            }).catch(() => { });
        },
        /**
         * @description 复选框勾选
         * @param {Array} rows 勾选的数据
        */
        handleSelectionChange (rows) {
            this.selected = rows;
        },
        // 页数改变
        sizeChange (data) {
            this.page.pageSize = data;
            this.getList();
        },
        // 切分页
        pageChange (data) {
            this.page.pageNo = data;
            this.getList();
        },
        // 关闭弹窗
        dialogClose () {
            this.$emit('components-close');
        }
    }
};
</script>

<style lang='less' scoped>
.dispatch-table-header {
    justify-content: space-between !important;
}
</style>
<style lang='less'>
.cancel-class {
    .el-message-box__content {
        display: flex;
        align-items: center;
        .el-message-box__container {
            margin-top: -7px;
            margin-right: 10px;
        }
        .el-message-box__input {
            flex: 2;
        }
    }
}
</style>
